import { useEffect } from 'react'
import { useAppContext } from '@/AppContext'
import useAppContextRef from '@/services/useAppContextRef'
import ElectronIPC from '@/services/ElectronIPC'

export function useAppCloseHandler() {
    const [_appState, appDispatch] = useAppContext()
    const { appStateRef } = useAppContextRef()

    useEffect(() => {
        // block window from closing if screen recording conversion in progress.
        const onWindowClosing = () => {
            if (appStateRef.current.appState.screenRecordingConversionProgress) {
                appDispatch({
                    type: 'update_app_state',
                    value: { isAppExitConfirmationDialogOpen: true },
                })
            } else {
                ElectronIPC.quitApp({ immediate: true })
            }
        }

        ElectronIPC.lockMainWindowClosing(true, onWindowClosing)

        return () => {
            ElectronIPC.lockMainWindowClosing(false, onWindowClosing)
        }
    }, [appDispatch, appStateRef])
}
